import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import React from "react";

import { AlertContainer, IconWrapper } from "./styles";

export const AlertMessage = (props) => {
    let { message = "Default Message", severity = "success" } = props;

    // Handle specific error object
    if (typeof message === "object" && message?.error?.name === "INCORRECT_EMAIL_PASSWORD") {
        message = "An error has occurred. Incorrect email or password.";
        severity = "error";
    } else if (typeof message === "object") {
        // Fallback for any other object
        message = message?.error?.desc || "An error occurred.";
    }

    return (
        <AlertContainer severity={severity}>
            {severity === "warning" && (
                <IconWrapper>
                    <WarningAmberIcon />
                </IconWrapper>
            )}
            {message}
        </AlertContainer>
    );
};
